import { render, staticRenderFns } from "./RectangleButton.vue?vue&type=template&id=fed67d12"
import script from "./RectangleButton.vue?vue&type=script&lang=js"
export * from "./RectangleButton.vue?vue&type=script&lang=js"
import style0 from "./RectangleButton.vue?vue&type=style&index=0&id=fed67d12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports